import React from "react";
import Box from "../../../components/box";

export default () => null;
